import { Box } from "@mui/material";
import { MetaValuePreviewProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function RichTextPreview({
  metaValueName,
  attributeMetaValues,
}: MetaValuePreviewProps) {
  const value = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  if (!value) return null;

  return <Box dangerouslySetInnerHTML={{ __html: value }} />;
}
